import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=fcfb3cc6&"
import script from "./submitDialog.vue?vue&type=script&lang=js&"
export * from "./submitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "submitDialog.vue"
export default component.exports